import { defineRule } from 'vee-validate'

const residentRegistrationNumber = () => {
  defineRule<string, any[]>(
    'resident_registration_number',
    (value, _target, _ctx: any) => {
      if (!value) {
        return true
      }
      return testResidentRegistrationNumber(value)
    },
  )
}

export default residentRegistrationNumber
